"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = root;
var _effects = require("redux-saga/effects");
var _reduxBatchedActions = require("redux-batched-actions");
var _sagas = require("../../utils/sagas");
var _mimeTypes = _interopRequireDefault(require("mime-types"));
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
var _uniqBy = _interopRequireDefault(require("lodash/uniqBy"));
var feedTypes = _interopRequireWildcard(require("../feeds/types"));
var types = _interopRequireWildcard(require("./types"));
var _apis = require("./apis");
var _selectors = require("../session/selectors");
var _actions = require("./actions");
var _actions2 = require("../notification/actions");
var _selectors2 = require("./selectors");
var _schemas = require("./schemas");
var _api = require("../../utils/api");
var _middlewares = require("../network/middlewares");
var _actions3 = require("../feeds/actions");
var _selectors3 = require("../feeds/selectors");
var _uuid = require("../../utils/uuid");
var _types3 = require("../websocket/types");
var _callbacks = _interopRequireDefault(require("../../callbacks"));
var _config = _interopRequireDefault(require("../../config"));
var _errorHandler = _interopRequireDefault(require("../../utils/errorHandler"));
var _i18n = _interopRequireDefault(require("../../utils/i18n"));
var _logger = _interopRequireDefault(require("../../utils/logger"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _logger.default('saga:feedItem');
function* patchFeedItem(action) {
  _callbacks.default.get('analyticsLogEvent')('feed_item_patch', {
    feedId: action._feed
  });
  logger.log('patchFeedItem', {
    action
  });
  try {
    var {
      feedItem
    } = action;
    var requestFeedItem = {
      content: feedItem.content
    };
    yield* (0, _api.normalizeApiResponse)(feedItem, _schemas.feedItems);
    yield (0, _effects.call)(_apis.$patchFeedItem, action._feed, feedItem.id, requestFeedItem);
  } catch (e) {
    if ((0, _middlewares.isNetworkError)(e)) {
      yield (0, _effects.put)((0, _actions2.addNotification)({
        message: _i18n.default.translate('network.error.timeout'),
        referenceError: 'FI6',
        error: e
      }));
    } else {
      yield (0, _effects.put)((0, _actions2.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'FI1',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'patchFeedItem');
    }
  }
}
function* deleteFeedItem(action) {
  _callbacks.default.get('analyticsLogEvent')('feed_item_delete', {
    feedId: action._feed
  });
  logger.log('deleteFeedItem', {
    action
  });
  try {
    yield (0, _effects.call)(_apis.$deleteFeedItem, action._feed, action._feedItem);
    yield (0, _effects.put)((0, _actions.requestDeleteLocalFeedItems)([action._feedItem]));
    yield (0, _effects.put)((0, _actions2.addNotification)({
      message: _i18n.default.translate('feed.feedBack.feedItemDeleted')
    }));
  } catch (e) {
    var _e$response;
    if ((0, _middlewares.isNetworkError)(e)) {
      yield (0, _effects.put)((0, _actions2.addNotification)({
        message: _i18n.default.translate('network.error.timeout'),
        referenceError: 'FI6',
        error: e
      }));
    } else if ((e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 404) {
      yield (0, _effects.put)((0, _actions.requestDeleteLocalFeedItems)([action._feedItem]));
    } else {
      yield (0, _effects.put)((0, _actions2.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'FI2',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'deleteFeedItem');
    }
  }
}
function* getFeedFilesLogic(action) {
  var _feed = action === null || action === void 0 ? void 0 : action._feed;
  logger.log('getFeedFilesLogic ', {
    _feed
  });
  try {
    var _result$data;
    var result = yield (0, _effects.call)(_apis.$getLastFilesFeedItems, _feed);
    var _fileFeedItems = yield* (0, _api.normalizeApiResponse)((_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.data, [_schemas.feedItems]);
    yield (0, _effects.put)((0, _actions.setFeedFiles)(_fileFeedItems, _feed));
  } catch (e) {
    yield (0, _effects.call)(_errorHandler.default.captureException, e, 'getFeedFilesLogic');
  }
}
function* postFeedItem(action) {
  var feedId = action.feedItem._feed;
  _callbacks.default.get('analyticsLogEvent')('feed_item_post', {
    feedId
  });
  logger.log('postFeedItem', {
    action
  });
  var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
  var _feedItem = action.feedItem.feedItem.id || (0, _uuid.generate)();
  var feedItem = _objectSpread(_objectSpread({
    id: _feedItem
  }, action.feedItem.feedItem), {}, {
    _client
  });
  try {
    var _feedItem$isSending;
    var now = new Date().toISOString();
    var _me = yield (0, _effects.select)(_selectors.getUserId);
    yield (0, _effects.put)((0, _actions.removeReplayableFeedItemFailed)(_feedItem));
    yield (0, _effects.call)(handleWsPostFeedItem, {
      payload: _objectSpread(_objectSpread({}, feedItem), {}, {
        _feed: feedId,
        createdAt: now,
        updatedAt: now,
        _user: _me,
        isFailed: false,
        failureCode: undefined,
        isSending: (_feedItem$isSending = feedItem.isSending) !== null && _feedItem$isSending !== void 0 ? _feedItem$isSending : true
      })
    });
    delete feedItem.isSending;
    yield (0, _effects.call)(_apis.$postFeedItem, feedId, feedItem);
  } catch (e) {
    var _e$response2, _e$response3, _e$response4;
    yield (0, _effects.put)((0, _actions.patchLocalFeedItem)(_feedItem, {
      isSending: undefined,
      isFailed: true,
      failureCode: (e === null || e === void 0 || (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : _e$response2.status) || (e === null || e === void 0 ? void 0 : e.code)
    }));
    if ((0, _middlewares.isNetworkError)(e)) {
      yield (0, _effects.put)((0, _actions.addReplayableFeedItemFailed)(_objectSpread(_objectSpread({
        _feedItem
      }, action.feedItem), {}, {
        feedItem
      })));
      yield (0, _effects.put)((0, _actions2.addNotification)({
        message: _i18n.default.translate('network.error.timeout')
      }));
    } else if ((e === null || e === void 0 || (_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : _e$response3.status) === 403) {
      yield (0, _effects.put)((0, _actions2.addNotification)({
        message: _i18n.default.translate('feedList.feedBack.deletedSubscription')
      }));
    } else if ((e === null || e === void 0 || (_e$response4 = e.response) === null || _e$response4 === void 0 ? void 0 : _e$response4.status) === 409) {
      // conflict may cause by the replay and the retry strategy from fetch
    } else {
      yield (0, _effects.put)((0, _actions2.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'FI3',
        error: e
      }));
    }
    yield (0, _effects.call)(_errorHandler.default.captureException, e, 'postFeedItem');
  }
}
function handleWsPostFeedItem(_ref) {
  var {
    payload
  } = _ref;
  return function* (_payload$isSending) {
    logger.log('handleWsPostFeedItem', {
      payload
    });
    var _selectedFeed = yield (0, _effects.select)(_selectors3.selectedFeedSelector);
    var {
      _feed
    } = payload;
    if (!_selectedFeed || _selectedFeed !== _feed) {
      yield (0, _effects.put)((0, _actions3.setAcknowledgement)(payload._feed, payload.createdAt));
      // feed is not selected, nothing to do with the feedItem
      return;
    }

    // HACK: overwrite the value because the feed is displayed
    var _feedItem = yield* (0, _api.normalizeApiResponse)(_objectSpread(_objectSpread({}, payload), {}, {
      isSending: (_payload$isSending = payload.isSending) !== null && _payload$isSending !== void 0 ? _payload$isSending : false,
      isUnread: false
    }), _schemas.feedItems);
    logger.log('handleWsPostFeedItem _feedItem', {
      _feedItem
    });
    yield (0, _effects.put)((0, _actions.addFeedItems)([_feedItem], _feed));
    yield (0, _effects.put)((0, _actions3.setAcknowledgement)(_feed, payload.createdAt));
  }();
}
function handleWsPutFeedItem(_ref2) {
  var {
    payload
  } = _ref2;
  return function* () {
    logger.log('handleWsPutFeedItem', {
      payload
    });
    var _selectedFeed = yield (0, _effects.select)(_selectors3.selectedFeedSelector);
    var {
      _feed
    } = payload;
    if (!_selectedFeed || _selectedFeed !== _feed) {
      // feed is not selected, nothing to do with the feedItem
      return;
    }
    yield* (0, _api.normalizeApiResponse)([payload], [_schemas.feedItems]);
  }();
}
function getFeedItemsLogic(_ref3) {
  var {
    _feed,
    reset,
    delta
  } = _ref3;
  return function* () {
    var batchedActions = [];
    var isFetching = yield (0, _effects.select)((0, _selectors2.isFetchingFeedItemsByFeedSelector)(_feed));
    var isEndReachedAlready = yield (0, _effects.select)((0, _selectors2.isEndReachedFeedItemsByFeedSelector)(_feed));
    var sendAck = false;
    if (!reset && (isFetching || isEndReachedAlready && !delta)) {
      logger.log('FeedItemsLogic rejected', {
        _feed,
        reset,
        delta,
        isFetching,
        isEndReachedAlready
      });
      return;
    }
    logger.log('FeedItemsLogic', {
      _feed,
      reset,
      delta,
      isFetching,
      isEndReachedAlready
    });
    yield (0, _effects.put)((0, _actions.setIsFetching)(_feed, true));
    try {
      var _deleted;
      var newestFeedItem = yield (0, _effects.select)(_selectors2.getNewestFeedItemByFeed, _feed);
      var response;
      var deleted = [];
      var updated = [];
      var launchDelta = !reset && delta && newestFeedItem;
      if (launchDelta) {
        try {
          var _response$data, _response$data2;
          response = yield (0, _effects.call)(_apis.$getDeltaFeedItems, _feed, newestFeedItem.updatedAt);
          if ((_response$data = response.data) !== null && _response$data !== void 0 && (_response$data = _response$data.deleted) !== null && _response$data !== void 0 && _response$data.length) deleted = response.data.deleted;
          if ((_response$data2 = response.data) !== null && _response$data2 !== void 0 && (_response$data2 = _response$data2.updated) !== null && _response$data2 !== void 0 && _response$data2.length) updated = response.data.updated;
        } catch (e) {
          var _e$response5;
          if ((e === null || e === void 0 || (_e$response5 = e.response) === null || _e$response5 === void 0 ? void 0 : _e$response5.status) === 413) {
            return yield (0, _effects.call)(getFeedItemsLogic, {
              reset: true,
              _feed
            });
          } else {
            throw e;
          }
        }
      } else {
        var _response$data3;
        var oldestFeedItem = reset ? undefined : yield (0, _effects.select)(_selectors2.getOldestFeedItemByFeed, _feed);
        response = yield (0, _effects.call)(_apis.$getPreviousFeedItems, _feed, oldestFeedItem === null || oldestFeedItem === void 0 ? void 0 : oldestFeedItem.id, oldestFeedItem === null || oldestFeedItem === void 0 ? void 0 : oldestFeedItem.createdAt);
        if ((_response$data3 = response.data) !== null && _response$data3 !== void 0 && _response$data3.length) updated = response.data;
      }
      var feedItems = updated.map(feedItem => _objectSpread(_objectSpread({}, feedItem), {}, {
        isSending: false
      }));
      if (feedItems.length) {
        var _response;
        if (delta) sendAck = true;else sendAck = (0, _api.getContentRange)((_response = response) === null || _response === void 0 ? void 0 : _response.headers).minRange === 0;
      }
      var {
        result,
        batchedAction
      } = yield* (0, _api.normalizeApiResponse)(feedItems, [_schemas.feedItems], true);
      batchedActions.push(batchedAction);
      var isEndReached = !(0, _api.hasRemainingItems)(response);
      if (isEndReached !== isEndReachedAlready && !launchDelta) {
        batchedActions.push((0, _actions.setFeedItemIsEndReached)(_feed, isEndReached));
        if (isEndReached) {
          var firstFeedItem = feedItems.reduce((acc, f) => {
            var _acc;
            if (!((_acc = acc) !== null && _acc !== void 0 && _acc.createdAt) || new Date(f.createdAt).getTime() < new Date(acc.createdAt).getTime()) {
              acc = f;
            }
            return acc;
          }, {});
          batchedActions.push((0, _actions.setFirstFeedItem)(_feed, firstFeedItem.id));
        }
      }
      if (reset) {
        batchedActions.push((0, _actions.setFeedItems)(result, _feed));
      } else {
        batchedActions.push((0, _actions.addFeedItems)(result, _feed));
      }
      if ((_deleted = deleted) !== null && _deleted !== void 0 && _deleted.length) {
        batchedActions.push((0, _actions.removeFeedItems)(deleted, _feed));
      }
    } catch (e) {
      var _e$response6;
      if ((e === null || e === void 0 || (_e$response6 = e.response) === null || _e$response6 === void 0 ? void 0 : _e$response6.status) === 416) {
        batchedActions.push((0, _actions.setFeedItemIsEndReached)(_feed, true));
      } else {
        if (!(0, _middlewares.isNetworkError)(e)) {
          batchedActions.push((0, _actions2.addNotification)({
            message: _i18n.default.translate('default.error'),
            referenceError: 'FI4',
            error: e
          }));
          yield (0, _effects.call)(_errorHandler.default.captureException, e, 'getFeedItemsLogic');
        }
      }
    }
    var _selectedFeed = yield (0, _effects.select)(_selectors3.selectedFeedSelector);
    if (_selectedFeed === _feed) {
      yield (0, _effects.put)((0, _reduxBatchedActions.batchActions)(batchedActions));
      yield (0, _effects.put)((0, _actions.setIsFetching)(_feed, false));
      if (sendAck) {
        yield (0, _effects.delay)(1000);
        yield (0, _effects.put)((0, _actions3.requestPostAcknowledgement)(_feed));
      }
    } else {
      yield (0, _effects.put)((0, _actions.setIsFetching)(_feed, false));
    }
  }();
}
function* clearFeed(action) {
  logger.log('clearFeed', {
    action
  });
  var {
    id: _feed
  } = action.payload || {};
  if (_feed) {
    var feedItemsEntities = yield (0, _effects.select)(_selectors2.feedItemEntitySelector);
    if (feedItemsEntities) {
      var uselessFeedItems = [];
      Object.keys(feedItemsEntities).forEach(_feedItem => {
        if (feedItemsEntities[_feedItem]._feed === _feed) {
          uselessFeedItems.push(_feedItem);
        }
      });
      yield (0, _effects.put)((0, _actions.requestDeleteLocalFeedItems)(uselessFeedItems));
    }
  }
}
function* postFeedFile(action) {
  logger.log('postFeedFile', {
    action
  });
  var feedId = action._feed;
  _callbacks.default.get('analyticsLogEvent')('feed_item_file_post', {
    feedId
  });

  // 100MB default
  var fileSizeUploadLimit = yield _callbacks.default.get('getFileUploadSizeLimit')() || 104857600;
  var _feedItem = (0, _uuid.generate)();
  var now = new Date().toISOString();
  var _me = yield (0, _effects.select)(_selectors.getUserId);
  var data;
  var meta;
  try {
    var {
      filename
    } = action;

    // web is object, mobile is string
    if (typeof action.file === 'object') {
      var _data$type, _data$type$startsWith;
      data = action.file;
      var extension = data.type ? ".".concat(_mimeTypes.default.extension(data.type)) : undefined;
      var isDisplayable = (_data$type = data.type) === null || _data$type === void 0 || (_data$type$startsWith = _data$type.startsWith) === null || _data$type$startsWith === void 0 ? void 0 : _data$type$startsWith.call(_data$type, 'image');
      var width, height;
      if (isDisplayable) {
        var fileSize = yield _callbacks.default.get('getFileSize')(data);
        width = fileSize === null || fileSize === void 0 ? void 0 : fileSize.width;
        height = fileSize === null || fileSize === void 0 ? void 0 : fileSize.height;
      }
      meta = {
        mimeType: data.type,
        name: filename,
        extension,
        width,
        height,
        isDisplayable
      };
    } else {
      var _data$type2, _data$type2$startsWit;
      var _extension = ".".concat(_mimeTypes.default.extension(action.fileType));
      var {
        size
      } = yield _callbacks.default.get('getFileSize')(action.file);
      if (!filename) {
        filename = yield _callbacks.default.get('getFilename')(action.file);
      }
      if (filename.split('.').length === 1) {
        filename += ".".concat(_extension);
      }
      data = {
        file: action.file,
        filename,
        _feed: feedId,
        type: action.fileType
      };
      meta = {
        mimeType: data.type,
        name: filename,
        extension: _extension,
        isDisplayable: (_data$type2 = data.type) === null || _data$type2 === void 0 || (_data$type2$startsWit = _data$type2.startsWith) === null || _data$type2$startsWit === void 0 ? void 0 : _data$type2$startsWit.call(_data$type2, 'image'),
        size
      };
    }
    if (action.fileSize) {
      // If we know the file size we check
      // if the file is under the allowed size
      if (action.fileSize > fileSizeUploadLimit) {
        throw new Error('FILE_UPLOAD_LIMIT');
      }
    } // End file size check

    yield (0, _effects.call)(handleWsPostFeedItem, {
      payload: {
        metasFile: _objectSpread(_objectSpread({}, data), meta),
        id: _feedItem,
        _feed: feedId,
        createdAt: now,
        updatedAt: now,
        _user: _me,
        isSending: true,
        content: action.content
      }
    });
    var {
      data: uploadUrl
    } = yield (0, _effects.call)(_apis.$requestGetFilePostUrl, feedId);
    var onUploadProgress = _ref4 => {
      var {
        loaded,
        total
      } = _ref4;
      if (!isNaN(loaded) && !isNaN(total)) {
        _callbacks.default.get('dispatch')((0, _actions.setFeedItemProgression)(feedId, _feedItem, loaded, total));
      }
    };
    var response = yield (0, _effects.call)(_apis.$requestPostFile, data, uploadUrl, onUploadProgress);
    yield (0, _effects.call)(postFeedItem, {
      feedItem: {
        _feed: feedId,
        feedItem: {
          isSending: false,
          id: _feedItem,
          metasFile: response.data[0],
          content: action.content
        }
      }
    });
  } catch (e) {
    var _e$response7, _e$response8, _e$response9;
    logger.error('postFeedFile', e);
    var failureCode = e === null || e === void 0 || (_e$response7 = e.response) === null || _e$response7 === void 0 ? void 0 : _e$response7.status;
    var failureMessage = (e === null || e === void 0 || (_e$response8 = e.response) === null || _e$response8 === void 0 || (_e$response8 = _e$response8.data) === null || _e$response8 === void 0 ? void 0 : _e$response8.message) || _i18n.default.translate('default.error');
    var failureMessageToaster = failureMessage;
    yield (0, _effects.put)((0, _actions.requestDeleteLocalFeedItems)([_feedItem]));
    yield (0, _effects.put)((0, _actions.resetFeedItemProgression)(feedId, _feedItem));
    yield (0, _effects.call)(_errorHandler.default.captureException, e, 'postFeedFile');

    // Local file upload limit or remote server rejection
    if (e.message === 'FILE_UPLOAD_LIMIT' || (e === null || e === void 0 || (_e$response9 = e.response) === null || _e$response9 === void 0 ? void 0 : _e$response9.status) === 413) {
      failureMessage = _i18n.default.translate('error.feedItems.upload.limit');
      // 413 - Request Entity Too Large
      var humanMBLimit = fileSizeUploadLimit / 1024 / 1024;
      failureMessageToaster = _i18n.default.translate('error.feedItems.upload.limitInfo', {
        humanMBLimit
      });
    }
    yield (0, _effects.put)((0, _actions2.addNotification)({
      message: failureMessageToaster,
      referenceError: 'FI5',
      key: failureMessageToaster !== failureMessage ? 'file-upload-size-limit' : 'file-upload-error'
    }));
    var _errorFeedItem = (0, _uuid.generate)();
    // Add a note that the file failed upload
    var feedItem = {
      _feed: feedId,
      feedItem: {
        isSending: false,
        isFailed: true,
        failureCode,
        id: _errorFeedItem,
        metasFile: action.file,
        content: action.content
      }
    };
    meta.isDisplayable = false;
    yield (0, _effects.put)((0, _actions.addFeedItems)([feedItem], feedId));
    yield (0, _effects.call)(handleWsPostFeedItem, {
      payload: {
        metasFile: _objectSpread(_objectSpread({}, data), meta),
        id: _errorFeedItem,
        _feed: feedId,
        createdAt: now,
        updatedAt: now,
        _user: _me,
        isSending: false,
        isFailed: true,
        isEditable: false,
        failureCode,
        failureMessage,
        isDisplayable: false,
        content: action.content
      }
    });
  }
}
function getLastFilesSharedLogic(_ref5) {
  var {
    type
  } = _ref5;
  return function* () {
    logger.log('getLastFilesSharedLogic ');
    if (type === _types3.WS_CONNECT && !_config.default.dashboard.fetchOnWsReload) {
      return;
    }
    try {
      var result = yield (0, _effects.call)(_apis.$getLastFilesFeedItems, null, _config.default.maxLastFileFeedItems);
      var _fileFeedItems = yield* (0, _api.normalizeApiResponse)(result.data, [_schemas.lastFileFeedItems]);
      yield (0, _effects.put)((0, _actions.setLastFileFeedItems)(_fileFeedItems));
    } catch (e) {
      if (!(0, _middlewares.isNetworkError)(e)) {
        yield (0, _effects.call)(_errorHandler.default.captureException, e, 'getLastFilesSharedLogic');
      }
    }
  }();
}
function updateLastFilesSharedLogic(_ref6) {
  var {
    type,
    payload
  } = _ref6;
  return function* () {
    logger.log('updateLastFilesSharedLogic', {
      type,
      payload
    });
    try {
      var _payload$metasFile;
      if ((_payload$metasFile = payload.metasFile) !== null && _payload$metasFile !== void 0 && _payload$metasFile.id) {
        var lastFileFeedItems = yield (0, _effects.select)(_selectors2.getLastFileFeedItems);
        lastFileFeedItems.push(payload);
        var newItems = (0, _uniqBy.default)((0, _sortBy.default)(lastFileFeedItems, o => -1 * new Date(o.updatedAt).getTime()), 'id').slice(0, _config.default.maxLastFileFeedItems);
        var _fileFeedItems = yield* (0, _api.normalizeApiResponse)(newItems, [_schemas.lastFileFeedItems]);
        yield (0, _effects.put)((0, _actions.setLastFileFeedItems)(_fileFeedItems));
      }
    } catch (e) {
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'updateLastFilesSharedLogic');
    }
  }();
}
function* replayItemsInError() {
  logger.log('replayItemsInError');
  try {
    var feedItems = yield (0, _effects.select)(_selectors2.replayableFailureItemsSelector);
    for (var feedItem of feedItems) {
      yield (0, _effects.put)((0, _actions.requestPostFeedItem)(feedItem));
    }
  } catch (e) {
    yield (0, _effects.call)(_errorHandler.default.captureException, e, 'replayItemsInError');
  }
}
function handleSwitchingToFeed(_ref7) {
  var {
    _feed,
    selected
  } = _ref7;
  return function* () {
    logger.log('handleSwitchingToFeed', {
      _feed,
      selected
    });
    try {
      if (!_feed) return;
      if (selected) {
        yield (0, _effects.put)((0, _actions3.updateSubscriptionFeedTyping)(_feed, false));
        yield (0, _effects.put)((0, _actions3.subscribeFeedTyping)(_feed));
        yield (0, _effects.call)(getFeedItemsLogic, {
          _feed,
          delta: true
        });
      } else {
        yield (0, _effects.put)((0, _actions3.unsubscribeFeedTyping)(_feed));
      }
    } catch (e) {
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'handleSwitchingToFeed');
    } finally {
      if (yield (0, _effects.cancelled)()) {
        yield (0, _effects.put)((0, _actions.setIsFetching)(_feed, false));
      }
    }
  }();
}
function* root() {
  yield (0, _effects.all)([(0, _sagas.takeLatest)(feedTypes.SET_SELECTED_FEED, handleSwitchingToFeed), (0, _sagas.takeEvery)(types.REQUEST_GET_FEED_ITEMS, getFeedItemsLogic), (0, _sagas.takeEvery)(types.REQUEST_GET_FEED_FILES, getFeedFilesLogic), (0, _sagas.takeEvery)(types.REQUEST_DELETE_FEED_ITEM, deleteFeedItem), (0, _sagas.takeEvery)(types.REQUEST_PATCH_FEED_ITEM, patchFeedItem), (0, _sagas.takeEvery)(types.REQUEST_POST_FEED_ITEM, postFeedItem), (0, _sagas.takeEvery)(types.WS_POST_FEED_ITEM, handleWsPostFeedItem), (0, _sagas.takeEvery)(types.WS_PUT_FEED_ITEM, handleWsPutFeedItem), (0, _sagas.takeEvery)(feedTypes.WS_DELETE_FEED, clearFeed), (0, _sagas.takeEvery)(types.REQUEST_POST_FEED_FILE, postFeedFile), (0, _sagas.takeLatest)([_types3.WS_CONNECT, types.WS_DELETE_FEED_ITEM], getLastFilesSharedLogic), (0, _sagas.takeEvery)(_types3.WS_CONNECT, replayItemsInError), (0, _sagas.takeLatest)(types.WS_POST_FEED_ITEM, updateLastFilesSharedLogic)]);
}
module.exports = exports.default;